import * as Request from '../Request';

const PushMessage = {
  // 推送更新信息分页列表
  getList: (data) => {
    return Request.post('/push/message/list', data);
  },
  // 新增
  add: (data) => {
    return Request.post('/push/message/save', data);
  },
  // 修改（仅待发布状态）
  update: (data) => {
    return Request.put('/push/message/update', data);
  },
  // 删除（仅待发布状态）
  del: (data) => {
    return Request.del('/push/message/delete', data);
  },
  // 发送到用户端（推送到各租户所有用户的站内信）
  publish: (data) => {
    return Request.postQuery('/push/message/publish', data);
  },
  // 独立部署租户选项（仅配置了服务地址的租户/集团）
  independentTenants: (data) => {
    return Request.get('/push/message/independentTenants', data);
  }
}
export default PushMessage
